import { render } from "./VerificationEnd.vue?vue&type=template&id=25db0468"
import script from "./VerificationEnd.vue?vue&type=script&lang=js"
export * from "./VerificationEnd.vue?vue&type=script&lang=js"

import "./VerificationEnd.vue?vue&type=style&index=0&id=25db0468&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__